import React, { useState, useEffect } from "react";
import {
  createStyles,
  Theme,
  makeStyles,
  useTheme,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      margin: theme.spacing(1),
    },
  })
);

export interface TagData {
  name: string;
  slug: string;
  contentsWithTag: {
    __typename: string;
  }[];
}
interface TagChipsProps {
  tags: TagData[];
  header?: boolean;
}

export default function TagChips(props: TagChipsProps) {
  const classes = useStyles();
  const theme = useTheme();

  const tagArr = [...props.tags] as TagData[];
  const sortedTags = tagArr.sort((x, y) => {
    return x.contentsWithTag.length < y.contentsWithTag.length ? 1 : -1;
  });

  return (
    <React.Fragment>
      {props.header ? (
        <Typography variant="h6" gutterBottom color="primary">
          この記事のタグ
        </Typography>
      ) : null}

      {sortedTags.map((tag, i) => {
        return (
          <Chip
            className={classes.chip}
            key={i}
            color="primary"
            avatar={<Avatar>#</Avatar>}
            label={`${tag.name} (${tag.contentsWithTag.length})`}
            variant="outlined"
            clickable
            component="a"
            href={`/tags/${tag.slug}`}
          />
        );
      })}
    </React.Fragment>
  );
}
